export default __webpack_public_path__ + "static/media/Cinzia Ferrari.2341fa46.jpg";